<template>
    <div v-if="!agreement" class="alert cookies-policy-alert" role="alert">
        <div class="row">
            <div class="col-md-6 col-xs-7 offset-md-2 offset-xs-0 text-justify">
                <div>{{$lang('Ta witryna wykorzystuje pliki cookies do przechowywania informacji na Twoim komputerze. Pliki cookies stosujemy w celu świadczenia usług na najwyższym poziomie, w tym w sposób dostosowany do indywidualnych potrzeb. Korzystanie z witryny bez zmiany ustawień dotyczących cookies oznacza, że będą one zamieszczane w Twoim komputerze. W każdym momencie możesz dokonać zmiany ustawień dotyczących cookies.')}}</div>
            </div>
            <div class="col-md-2 col-xs-5 text-center">
                <a class="btn btn-primary m-1" :aria-label="$lang('Akceptuj politykę cookies')" href="#" @click.prevent="saveAgreement()">OK</a>
                <a class="btn btn-primary m-1" :aria-label="$lang('Polityka cookies - przejdź do szczegółów')" :href="urlCookiePolicy">{{ $lang('Polityka cookies')}}</a>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        name: "cookies-policy-alert-component",
        props: {
            isAgreement: {
                type: Boolean,
                required: true
            },
            urlCookiePolicy: {
                type: String,
                required: true
            },
            urlCookiePolicyAgreement: {
                type: String,
                required: true
            }
        },
        data: function () {
            return {
                agreement: true
            }
        },
        methods: {
            saveAgreement: function (e) {
                let self = this;
                axios.post(this.urlCookiePolicyAgreement, {}).then(({data}) => {
                    if (data.agreement) {
                        self.agreement = data.agreement;
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
        },
        created() {
            this.agreement = this.isAgreement;
        }
    }
</script>
